import React, {useEffect, useState} from "react";
import {Button, Modal} from "react-bootstrap";

interface Props {
    show: boolean,
    activity: any,
    onClose: () => void,
    onConfirm: () => void
}

export const DuplicateActivityModal: React.FC<Props> = (props) => {

    const [show, setShow] = useState(false)

    useEffect(() => {
        setShow(props.show)
    }, [props.show])

    return (
        <Modal show={show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Duplicar inscripción</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                ¿Deseas duplicar la inscripción "{props.activity?.name}"?
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant={"secondary"}
                    onClick={props.onClose}
                >
                    Cancelar
                </Button>
                <Button
                    className={"purple-btn"}
                    onClick={props.onConfirm}
                >
                    Duplicar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
